(function() {
  'use strict';

  function initDiscountForms() {
    document.querySelectorAll('.solaris-discount-form').forEach(function(form) {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';

      var input = form.querySelector('.solaris-discount-input');
      var btn = form.querySelector('.solaris-discount-btn');
      var msgEl = form.closest('.solaris-discount-wrap').querySelector('.solaris-discount-msg');

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var code = input.value.trim();
        if (!code) {
          showMsg(msgEl, 'Introdu un cod promotional.', 'error');
          return;
        }
        btn.disabled = true;
        btn.textContent = 'Se aplica...';

        // Use fetch to apply discount via /discount/CODE
        fetch('/discount/' + encodeURIComponent(code), {
          method: 'GET',
          redirect: 'follow'
        }).then(function(response) {
          // After applying, verify cart to see if discount was applied
          return fetch('/cart.js');
        }).then(function(response) {
          return response.json();
        }).then(function(cart) {
          var applied = false;
          // Check cart level discounts
          if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            applied = true;
          }
          // Check line item discounts
          if (!applied && cart.items) {
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].discounts && cart.items[i].discounts.length > 0) {
                applied = true;
                break;
              }
            }
          }
          // Check total_discount
          if (!applied && cart.total_discount && cart.total_discount > 0) {
            applied = true;
          }

          if (applied) {
            showMsg(msgEl, 'Codul promotional a fost aplicat cu succes!', 'success');
            input.value = '';
            // Reload to show updated prices
            setTimeout(function() { window.location.reload(); }, 800);
          } else {
            showMsg(msgEl, 'Codul promotional "' + code + '" nu este valid sau nu se aplica comenzii tale.', 'error');
            btn.disabled = false;
            btn.textContent = 'Aplica';
          }
        }).catch(function(err) {
          showMsg(msgEl, 'A aparut o eroare. Te rugam sa incerci din nou.', 'error');
          btn.disabled = false;
          btn.textContent = 'Aplica';
        });
      });
    });
  }

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'solaris-discount-msg solaris-discount-msg--' + type;
  }

  // Remove discount handler
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('solaris-discount-remove')) {
      e.preventDefault();
      e.target.disabled = true;
      e.target.textContent = 'Se sterge...';
      fetch('/discount/NONE', { method: 'GET', redirect: 'follow' })
        .then(function() {
          window.location.reload();
        })
        .catch(function() {
          window.location.reload();
        });
    }
  });

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountForms);
  } else {
    initDiscountForms();
  }

  // Re-init after cart drawer opens (MutationObserver for dynamic content)
  var observer = new MutationObserver(function(mutations) {
    initDiscountForms();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
